export default "__VITE_ASSET__UmARvrKV__"